import { Injectable } from '@angular/core';
import { provideToastr, ToastrService } from 'ngx-toastr';

export const provideToasts = provideToastr;

@Injectable({
  providedIn: 'root'
})
export class ToastService extends ToastrService {}
